
class NumbersEdit {

    [x: string]: any;
 	 static $inject = ['$stateParams','$state','$translate'];
    constructor($stateParams, $state, $translate) {
        this.$stateParams = $stateParams;
        this.$state = $state;
        this.$translate = $translate
    }

    visibleNumber() {
        return this.msisdn.msisdn ? (this.msisdn.msisdn) : (this.$translate.instant('PENDING') + '...')
    }

    updateLabel() {
        if (!this.msisdn.label) return;

        this.onUpdateLabel({ label: this.msisdn.label });
    }
}

export default {
    controller: NumbersEdit,
    template : require('./numbers.edit.html'),
    bindings: {
        msisdn: '<',
        onUpdateLabel: '&',
        placeholder: '<'
    }
}
